'use client'

import { useSession } from '@marketplace-web/shared/session-data'

import { ItemPageMakeOfferActionPluginModel } from './types'
import { ItemBuyerOfferModalContainer } from './ItemBuyerOfferModalContainer/ItemBuyerOfferModalContainer'
import { useShowStickyButtons, useCanTransact } from '../../hooks'

type Props = {
  data: ItemPageMakeOfferActionPluginModel
  isStickyButton?: boolean
}

const ItemPageMakeOfferActionPlugin = ({ data, isStickyButton = false }: Props) => {
  const {
    sellerId,
    canBuy,
    canInstantBuy,
    isReserved,
    isHidden,
    reservedForUserId,
    closetCountdownEndDate,
  } = data

  const canTransact = useCanTransact({
    canBuy,
    canInstantBuy,
    isReserved,
    isHidden,
    reservedForUserId,
    closetCountdownEndDate,
  })
  const { user } = useSession()
  const currentUserId = user?.id
  const isViewingOwnItem = sellerId === currentUserId

  const showStickyButtons = useShowStickyButtons({ isViewingOwnItem })
  const isButtonHidden = isViewingOwnItem || !canTransact || showStickyButtons !== isStickyButton

  if (isButtonHidden) return null

  return <ItemBuyerOfferModalContainer data={data} />
}

export default ItemPageMakeOfferActionPlugin
